import { render, staticRenderFns } from "./OperaProjectComprehenWindow.vue?vue&type=template&id=b5409ca2&scoped=true&"
import script from "./OperaProjectComprehenWindow.vue?vue&type=script&lang=js&"
export * from "./OperaProjectComprehenWindow.vue?vue&type=script&lang=js&"
import style0 from "./OperaProjectComprehenWindow.vue?vue&type=style&index=0&id=b5409ca2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5409ca2",
  null
  
)

export default component.exports